import { createTheme } from "@mui/material";

const { palette } = createTheme();
const { augmentColor } = palette;
const createColor = (mainColor) => augmentColor({ color: { main: mainColor } });

const defaultTextTheme = {
  fontFamily: `'Hind', 'Avenir', 'Helvetica', 'arial'`,
  fontSize: 16,
  fontWeight: 400,
};

const theme = createTheme({
  typography: {
    allVariants: {
      fontFamily: `'Hind', 'Avenir', 'Helvetica', 'arial'`,
      fontWeight: 400
    },
    button: {
      textTransform: "none",
      ...defaultTextTheme
    },
  },
  components: {
    MuiInputBase: {
      styleOverrides: {
        input: defaultTextTheme,
      },
    },
    MuiSelect: {
      styleOverrides: {
        select: defaultTextTheme,
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: defaultTextTheme,
      },
    },
    MuiButton: {
      styleOverrides: {
        outlined: {
          backgroundColor: 'white',
          "&:hover": {
            backgroundColor: "#e9ecf0",
            borderColor:"#7787f7"
          },
        }
      }
    }
  },
  palette: {
    cc: createColor("#7787f7")
  }
});

export default theme;
